import React, { Fragment, useEffect, useState } from 'react'
import { Box, Button, Grid, Paper, TextField } from '@mui/material'
import { useStyles } from './styles'
import { SkuVasDetail } from '../../../components/CaptureVasRule/types'
import { clsAlphaNoOnly } from '../../../utils/regex/regexFunctions'
import { usePagination } from '../../../hooks/usePagination'
import { useApi } from '../../../hooks/useApi'
import { getValidateFinishDetailVas } from './api'
import { Status } from '../../../hooks/useFetchState'
import { PickingValidateFinishDetailProps } from './typings'
import { GenericTableV2 } from '../../_EOS/GenericTable'
import { ApiResponse } from '../../../typings/ApiResponse'
import { getColumnsConfig } from './FinishDetailComponent/pickingValiationSkuVasDetailTableConfig'
import { SpeakerPhone } from '@mui/icons-material'
import { useModal } from '../../../hooks/useModal'
import { Modal } from '../../_EOS/Modal'
import { SelectVasRuleModal } from '../../CaptureVasRule/SelectVasRuleModal'
import { SnackBar } from '../../SnackBar/Snackbar'
import { useSnackbar } from '../../../hooks/useSnackbar'

export const PickingValidateFinishDetailVas: React.FC<
  PickingValidateFinishDetailProps
> = ({ pickingRouteId, onDataEmpty }) => {
  const classes = useStyles()
  const { state, callApi } = useApi<ApiResponse<SkuVasDetail>>()
  const [sku, setSku] = useState<string>('')
  const [skuFilter, setskuFilter] = useState<string>('')
  const [statusFilter, setStatusFilter] = useState<string>('')
  const { isActive, message, openSnackBar, isSuccess } = useSnackbar()
  const [titleModalVas, setTitleModalVas] = useState<string | undefined>('')

  const columnsConfig = getColumnsConfig()

  // metodos para api
  const requestDataFinishDetail = (page?: number, pageSize?: number) => {
    callApi(
      getValidateFinishDetailVas(
        skuFilter,
        pickingRouteId,
        statusFilter,
        page,
        pageSize
      )
    )
      .then((result: ApiResponse<SkuVasDetail>) => {
        if (result.totalItems === 0) {
          onDataEmpty?.()
        }
      })
      .catch((error) => {
        openSnackBar(error, false)
      })
  }

  const pagination = usePagination(5)

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestDataFinishDetail(auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  const handleChangeSku = (e: any) => {
    setSku(e.target.value)
  }

  const handleSearchSku = async (pSku: string, pStatusfilter: string) => {
    pagination.setPagination(0, pagination.pageSize)

    // limpia control del sku
    if (pSku === '') {
      setSku('')
    }
    setskuFilter(pSku)
    setStatusFilter(pStatusfilter)
  }

  const scanVasRule = useModal<SkuVasDetail>('')

  // Busca cuando cambian los filtros
  useEffect(() => {
    requestDataFinishDetail(pagination.page, pagination.pageSize)
  }, [skuFilter, statusFilter])

  const reloadData = () => {
    requestDataFinishDetail(pagination.page, pagination.pageSize)
  }

  return (
    <Fragment>
      <Paper style={{ marginBottom: '10px', padding: '16px' }}>
        <Grid container spacing={2} alignItems='center' justify='space-between'>
          {/* texto alineado a la izquierda */}
          <Grid item xs={6}>
            <TextField
              id='skuId'
              name='skuId'
              label='Buscar Producto'
              autoComplete='off'
              autoFocus
              value={sku}
              onChange={(e: any) => {
                handleChangeSku(e)
                clsAlphaNoOnly(e)
              }}
              onKeyPress={(evt: any) => {
                const keyCode = evt
                  ? evt.which
                    ? evt.which
                    : evt.keyCode
                  : evt.keyCode
                if (keyCode === 13) {
                  handleSearchSku(sku, '')
                }
              }}
              inputProps={{
                maxLength: 30,
                pattern: '[a-zA-Z0-9-]'
              }}
            />
            <Button
              type='submit'
              variant='contained'
              color='primary'
              className={classes.button}
              onClick={() => {
                handleSearchSku(sku, '')
              }}
            >
              {'BUSCAR'}
            </Button>
          </Grid>

          <Grid
            item
            xs={6}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.warning} ${classes.filterButton}`}
              onClick={() => {
                handleSearchSku('', '')
              }}
            >
              {'Limpiar Filtro'}
            </Button>
            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.sucess} ${classes.filterButton}`}
              id='btnCompleto'
              name='btnCompleto'
              value={'1-2'}
              onClick={() => {
                handleSearchSku('', '1-2')
              }}
            >
              {'Completo'}
            </Button>

            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.difference} ${classes.filterButton}`}
              name='btnDiferencia'
              id='btnDiferencia'
              value={'3-4'}
              onClick={() => {
                handleSearchSku('', '3-4')
              }}
            >
              {'Con Diferencias'}
            </Button>

            <Button
              type='submit'
              variant='contained'
              color='secondary'
              className={`${classes.button} ${classes.filterButton} ${classes.manage}`}
              id='btnGestionado'
              name='btnGestionado'
              value={'2-4'}
              onClick={() => {
                handleSearchSku('', '2-4')
              }}
            >
              {'Gestionado'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Paper>
        <Box>
          <Grid
            container
            spacing={2}
            alignContent='center'
            style={{ marginTop: '10px', marginBottom: '5px' }}
          >
            <Grid item xs={12} sm container>
              <Grid item xs={12} container direction='column' spacing={2}>
                <Grid item xs>
                  <GenericTableV2<SkuVasDetail>
                    columns={columnsConfig}
                    keyField={'skuId'}
                    data={state.data?.items || []}
                    pagination={{
                      total: state.data?.totalItems || 0,
                      page: pagination.page,
                      pageSize: pagination.pageSize,
                      onPageChange: handlePaginationChange
                    }}
                    loading={state.status === Status.Loading}
                    actions={[
                      {
                        key: 'scanVASCode',
                        label: 'Captura Servicio VAS',
                        onClick: (item) => scanVasRule.openModal('lg', item),
                        icon: <SpeakerPhone />
                      }
                    ]}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Modal
        open={scanVasRule.isOpen}
        maxWidth={scanVasRule.size}
        title={titleModalVas}
        onClose={scanVasRule.closeModal}
      >
        <SelectVasRuleModal
          SkuVasDetailData={scanVasRule.extendedProps}
          handleSnackbar={openSnackBar}
          handleCloseModal={scanVasRule.closeModal}
          setTitleModalVas={setTitleModalVas}
          onSaveSuccess={reloadData}
          autoSearch={true}
        />
      </Modal>

      <SnackBar
        message={message}
        status={isSuccess ? 'success' : 'error'}
        open={isActive}
      />
    </Fragment>
  )
}
